export default function isBreakpointMobile(breakpoint?: string) {
  return breakpoint === "base" || breakpoint === "xs" || breakpoint === "sm";
}
